import { Parkinglot, SharedParkinglot } from '@/components/detail/components/shared/parkinglotInfo/model'
import type { TicketsType } from '@/components/detail/components/shared/parkinglotInfo/model'

import { PARKINGLOT_TYPE } from '@/enums/detail'
import { MarkerType } from '@/enums/map'

export class Pin {
  seq: number
  lat: number
  lng: number
  name: string
  geohash: string
  price: number | undefined
  type: PARKINGLOT_TYPE // enum : P, S
  MarkerType: MarkerType
  zIndex: number
  tickets?: TicketsType[] | []
  isClosed?: boolean
  isFree?: boolean
  operationSeq?: number
  isPartner?: boolean

  getSortedTickets(tickets: TicketsType[]) {
    const sortedTickets = tickets.sort((a, b) => {
      if (a.isOpen !== b.isOpen) {
        return (b.isOpen ? 1 : 0) - (a.isOpen ? 1 : 0)
      } else if (a.price !== b.price) {
        return a.price - b.price
      } else {
        return a.couponName.localeCompare(b.couponName)
      }
    })
    return sortedTickets
  }

  getOrderedZIndex(parkinglotMarkerType: MarkerType) {
    switch (parkinglotMarkerType) {
      case MarkerType.Normal:
      case MarkerType.NormalNoPriceInfo:
      case MarkerType.NormalCurrentFree:
      case MarkerType.NormalAlwaysFree:
      case MarkerType.NormalDisabled:
        return 50
      case MarkerType.PartnerWithoutTicket:
        return 60
      case MarkerType.PartnerWithTicketDisabled:
        return 70
      case MarkerType.Sharing:
        return 80
      case MarkerType.PartnerWithTicket:
        return 90
      default:
        return 50
    }
  }

  getMarkerType(props: Parkinglot | SharedParkinglot) {
    if ('shareSeq' in props) {
      return MarkerType.Sharing
    } else {
      const sortedTickets = this.getSortedTickets(props.tickets)
      if (!props.isPartner) {
        if (props.operationSeq === 13) {
          return MarkerType.NormalAlwaysFree
        } else if (props.isFree) {
          return MarkerType.NormalCurrentFree
        } else if (props.isClosed) {
          return MarkerType.NormalDisabled
        } else if (!this.price) {
          return MarkerType.NormalNoPriceInfo
        }
        return MarkerType.Normal
      } else if (props.isPartner && sortedTickets) {
        if (sortedTickets.length === 0) {
          return MarkerType.PartnerWithoutTicket
        } else if (sortedTickets.length > 0) {
          if (sortedTickets.find((ticket) => ticket.isOpen)?.isOpen) {
            return MarkerType.PartnerWithTicket
          }
        }
        return MarkerType.PartnerWithTicketDisabled
      } else return MarkerType.Normal
    }
  }

  getMarkerName() {
    if (this.tickets && this.tickets.length > 0) {
      return this.tickets[0].couponName
    } else {
      return this.name
    }
  }

  getMarkerPrice() {
    if (this.tickets && this.tickets.length > 0) {
      return this.tickets[0].price.toLocaleString()
    } else {
      return this.price?.toLocaleString() ?? 'P'
    }
  }

  constructor(props: Parkinglot | SharedParkinglot) {
    if ('parkinglotSeq' in props) {
      this.seq = props.parkinglotSeq
      this.lat = props.latitude
      this.lng = props.longitude
      this.name = props.name
      this.geohash = props.geohash
      this.price = props.calcPrice['60']
      this.type = PARKINGLOT_TYPE.PARKINGLOT
      this.MarkerType = this.getMarkerType(props)
      this.tickets = this.getSortedTickets(props.tickets)
      this.isClosed = props.isClosed || false
      this.isFree = props.isFree
      this.operationSeq = props.operationSeq
      this.zIndex = this.getOrderedZIndex(this.getMarkerType(props))
      this.isPartner = props.isPartner
    } else {
      this.seq = props.shareSeq
      this.lat = props.latitude
      this.lng = props.longitude
      this.name = props.name
      this.geohash = props.geohash
      this.price = props.calcPrice['60']
      this.type = PARKINGLOT_TYPE.SHARE
      this.MarkerType = this.getMarkerType(props)
      this.zIndex = this.getOrderedZIndex(this.getMarkerType(props))
    }
  }
}
